// import callApi from "@repo/next-shared/utils/api";
import { useQuery } from "@tanstack/react-query";
import { getBrand } from "@/actions/brands";

// export async function getBrand() {
//   return await callApi({ path: "/catalog/brand", method: "GET" });
// }

export function useBrandBase(select: any): any {
  return useQuery({
    queryKey: ["brand"],
    queryFn: () => getBrand(),
    select,
  });
}

export function useBrand(): any {
  return useBrandBase((brands: string[]) => brands);
}

export function useBrandMenu(): any {
  const secondary = [
    "Nike",
    "Adidas",
    "The North Face",
    "Polo Ralph Lauren",
    "Lacoste",
    "Barbour",
    "C.P. Company",
    "K-Way",
    "Dondup",
    "New Balance",
    "Converse",
    "Dr. Martens",
    "Hoka",
    "On",
    "Birkenstock",
    "Asics",
    "Saucony",
    "Iuter",
    "Brooks",
    "Ray-Ban",
    "Mizuno",
    "Oakley",
    "Under Armour",
    "Vision Of Super",
  ];
  const brands = {
    id: "",
    productCode: "",
    title: "Brand",
    imgUrl: "",
    showOnHome: false,
    isBrand: true,
    children: secondary.map((brand: string) => ({
      id: "",
      productCode: "",
      title: brand,
      imgUrl: "",
      showOnHome: false,
      isBrand: true,
    })),
  };

  return brands;
}
